// Dismissal persistence for the first-run onboarding UI (docs/10 #2.5). Two
// independent flags per org: the getting-started checklist and the dashboard
// welcome banner can be closed separately, and neither ever reappears once
// dismissed (mirrors the localStorage try/catch pattern in api/org-store.ts).

const CHECKLIST_KEY = 'sl_onboarding_checklist_dismissed';
const WELCOME_KEY = 'sl_onboarding_welcome_dismissed';

function readSet(key: string): Set<string> {
  try {
    const raw = localStorage.getItem(key);
    return raw ? new Set(JSON.parse(raw) as string[]) : new Set();
  } catch {
    return new Set();
  }
}

function addToSet(key: string, orgId: string): void {
  try {
    const set = readSet(key);
    set.add(orgId);
    localStorage.setItem(key, JSON.stringify([...set]));
  } catch {
    /* private mode / storage disabled — dismissal just won't persist */
  }
}

export function isChecklistDismissed(orgId: string): boolean {
  return readSet(CHECKLIST_KEY).has(orgId);
}

export function dismissChecklist(orgId: string): void {
  addToSet(CHECKLIST_KEY, orgId);
}

export function isWelcomeDismissed(orgId: string): boolean {
  return readSet(WELCOME_KEY).has(orgId);
}

export function dismissWelcome(orgId: string): void {
  addToSet(WELCOME_KEY, orgId);
}
